// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"f7e18ad0","206":"7f27c1f8","233":"9bc62743","453":"74deec0c","481":"ea3660a3","509":"60d347a2","599":"de99bddc","723":"d01f2e7a","803":"f93bb85d","826":"93d72992"}[chunkId] + ".chunk.js";
};